/**
 * Swap two columns order
 * @param {object} data
 * @param {string} key 
 */
export const BuildOptions = (data, key) => (Object.keys(data[key]).map(function (d) { return { value: d, label: data[key][d] }; }) || []);